import { Input, InputOverrides } from 'baseui/input'
import { forwardRef } from 'react'
import { useOverrides } from '../hooks/use-overrides'
import { BaseInput, BaseInputProps } from './'
import { LabelM, LabelS } from '../base-typography'
import { useInputStyle } from './use-input-style'

export const BaseInputWithLabel = forwardRef<Input, BaseInputProps>(
  (
    { overrides, label, size = 'l', action, onAction, disabled, ...props },
    ref
  ) => {
    const {
      getLabelColor,
      getWithLabelSize,
      getActionColor,
      getWithLabelActionPostioin,
    } = useInputStyle()

    return (
      <BaseInput
        overrides={useOverrides<InputOverrides>(
          {
            Input: {
              style: {
                ...getWithLabelSize(size),
              },
            },
            After: {
              component: (props: any) => (
                <LabelM
                  $style={{
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    zIndex: 2,
                    position: 'absolute',
                    right: '14px',
                    ...getWithLabelActionPostioin(size),
                    ...getActionColor(props),
                  }}
                  onClick={onAction}
                >
                  {action}
                </LabelM>
              ),
            },
            Before: {
              component: (props: any) => (
                <LabelS
                  $style={{
                    position: 'absolute',
                    top: size === 'l' ? '6px' : '2px',
                    left: '14px',
                    ...getLabelColor(props),
                    pointerEvents: 'none',
                    transitionProperty: 'color',
                    transitionDuration: '0.5s',
                  }}
                >
                  {label}
                </LabelS>
              ),
            },
            MaskToggleButton: {
              props: {
                tabindex: -1,
                title: '비밀번호 표시',
                'aria-label': '비밀번호 표시',
              },
            },
            MaskToggleHideIcon: {
              props: {
                title: '비밀번호 표시',
                'aria-label': '비밀번호 표시',
              },
            },
            MaskToggleShowIcon: {
              props: {
                title: '비밀번호 표시',
                'aria-label': '비밀번호 표시',
              },
            },
          },
          overrides
        )}
        disabled={disabled}
        {...props}
        ref={ref}
      />
    )
  }
)
